import React, { useState, useEffect, useCallback } from 'react';

const TranslatedValue = (props) => {
    const { translate, lang, label } = props;
    const [value, setValue] = useState(label);

    useEffect(() => {
        let isCancelled = false;

        if (translate) {
            translate(label, lang).then((result) => {
                if (!isCancelled) {
                    setValue(result);
                }
            });
        }

        return () => {
            isCancelled = true;
        };
    }, [lang]);

    if (!translate) {
        return label;
    }

    return (
        <React.Fragment>{value}</React.Fragment>
    );
}

const withTranslations = Component => {
    const TranslatedComponent = (props) => {
        const { $translate: translate, languageService } = props;

        const [lang, setLang] = useState(null);

        useEffect(() => {
            let isCancelled = false;
            let sub = null;

            if (languageService) {
                sub = languageService.current().subscribe((newLang) => {
                    if (!isCancelled) {
                        setLang(newLang);
                    }
                });
            }

            return () => {
                isCancelled = true;

                if (sub) {
                    sub.unsubscribe();
                }
            };
        }, []);

        const t = useCallback((label) => {
            return (<TranslatedValue translate={translate} lang={lang} label={label} />);
        }, [lang]);

        if (!languageService) {
            console.error("Please inject 'languageService' into the component", Component);
            return null;
        }

        if (!translate) {
            console.error("Please inject '$translate' into the component", Component);
            return null;
        }

        return (<Component t={t} {...props} />);
    };

    return TranslatedComponent;
};

export { withTranslations };